import React from "react";
import ListItemReversedTextView from "../../../../../common/components/ListItemReversedTextView";
import {PartOfSpeech} from "../../../../../common/types/words";

export interface PartOfSpeechResultViewProps {
    partOfSpeech: PartOfSpeech;
}

export default function PartOfSpeechResultView({partOfSpeech}: PartOfSpeechResultViewProps) {

    if (!partOfSpeech) {
        return null;
    }

    return (
        <ListItemReversedTextView title="Part of Speech" content={partOfSpeech}/>
    );
}
